export default "__VITE_ASSET__BaE6eJ86__"